module.exports = __webpack_public_path__ + "media/images/camera-936b68e0e134c01f0da0f9dc083eb728.svg";